import { render, staticRenderFns } from "./dialog-filters.vue?vue&type=template&id=63d72a87"
import script from "./dialog-filters.vue?vue&type=script&lang=js"
export * from "./dialog-filters.vue?vue&type=script&lang=js"
import style0 from "./dialog-filters.vue?vue&type=style&index=0&id=63d72a87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports